export const officePage = 'https://madefalva.ro';
export const livePage = 'https://visitmadefalva.ro';
